import { matrixPriority, priorityName, type MatrixLevel, type TicketMatrix } from '../api/priorityMatrix'

/**
 * Urgenta + impact pe un formular de tichet, si prioritatea care iese din ele.
 *
 * Folosit de formularul de tichet nou si de banda de pe fisa. Nu scrie nimic:
 * spune ce a ales omul (`onUrgency` / `onImpact`) si arata prioritatea pe care
 * o va scrie serverul. Impactul sugerat din CI-urile afectate apare ca un
 * buton - sugestie, nu alegere facuta in locul omului.
 */
export function PriorityMatrixFields({
  matrix,
  urgency,
  impact,
  onUrgency,
  onImpact,
  idPrefix,
  disabled = false,
}: {
  matrix: TicketMatrix
  urgency: number
  impact: number
  onUrgency(next: number): void
  onImpact(next: number): void
  idPrefix: string
  disabled?: boolean
}) {
  const computed = matrixPriority(matrix, urgency, impact)
  const suggested = matrix.suggestion?.impact_id ?? null
  const suggestedLevel = suggested ? matrix.impacts.find((l) => l.ID === suggested) : undefined

  return (
    <div className="tk-priority-matrix">
      <LevelSelect id={`${idPrefix}-urgency`} label="Urgency" levels={matrix.urgencies} value={urgency} onChange={onUrgency} disabled={disabled} />
      <LevelSelect id={`${idPrefix}-impact`} label="Impact" levels={matrix.impacts} value={impact} onChange={onImpact} disabled={disabled} />

      {suggestedLevel && suggested !== impact && (
        <div className="form-group">
          <div className="col-sm-offset-3 col-sm-9">
            <button type="button" className="btn btn-link btn-xs tk-impact-suggestion" disabled={disabled} onClick={() => onImpact(suggested as number)}>
              <i className="fas fa-lightbulb" aria-hidden="true"></i> Suggested impact: {suggestedLevel.name} ({matrix.suggestion?.affected} affected
              items)
            </button>
          </div>
        </div>
      )}

      <div className="form-group">
        <label className="col-sm-3 control-label">Calculated priority</label>
        <div className="col-sm-9">
          <p className="form-control-static tk-matrix-priority">
            {computed !== null ? (
              <strong>{priorityName(matrix.priorities, computed)}</strong>
            ) : urgency > 0 && impact > 0 ? (
              <span className="text-muted">The matrix has no priority for this pair; the chosen priority is kept.</span>
            ) : (
              <span className="text-muted">Choose urgency and impact.</span>
            )}
          </p>
        </div>
      </div>
    </div>
  )
}

function LevelSelect({
  id,
  label,
  levels,
  value,
  onChange,
  disabled,
}: {
  id: string
  label: string
  levels: MatrixLevel[]
  value: number
  onChange(next: number): void
  disabled: boolean
}) {
  return (
    <div className="form-group">
      <label htmlFor={id} className="col-sm-3 control-label">
        {label}
      </label>
      <div className="col-sm-9">
        <select id={id} className="form-control" value={value} disabled={disabled} onChange={(e) => onChange(Number(e.target.value))}>
          <option value={0}>- choose -</option>
          {levels.map((level) => (
            <option key={level.ID} value={level.ID}>
              {level.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  )
}
